import React from 'react'
import {AboutBG} from '../Assets'
import StaticsImages from './Statics'
import {AboutData} from '../../utils/static'
import AwardBadge from "../Badge";

const Right = () => {
    return (
        <div className="py-2 flex-1 flex items-center relative">
            <img src={AboutBG} alt="" className='blur-sm ml-auto lg:h-[550px] h-[420px] w-full lg:w-auto'/>
            <StaticsImages items={AboutData}/>
        </div>
    )
}

export default Right